import { useCallback, useMemo } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { has, isPlainObject, isString } from 'lodash';
import { FlowResourceType, useEnvironment, useEditorStore } from '@diana/core';
import { routeUrls } from '../../../app/Routing/RouteUrls';

export const useClosePage = () => {
  const environment = useEnvironment();
  const navigate = useNavigate();
  const location = useLocation();

  const flowResourceType = useEditorStore((s) => s.flow?.properties.flowResourceType);

  const canNavigateBack = useMemo(() => {
    if (isPlainObject(location.state)) {
      if (has(location.state, 'fromPathName')) {
        if (isString(location.state.fromPathName)) {
          const validPaths: string[] = [
            routeUrls.thingsGroups.path,
            routeUrls.workflows.path,
            routeUrls.workboard.path,
            routeUrls.things.path,
          ];
          return validPaths.some((validPath) => {
            const validPathAccessors = validPath.split('/');
            const prevPathAccessors = location.state.fromPathName.split('/');
            return validPathAccessors.every((accessor, index) => {
              if (accessor.startsWith(':') && isString(prevPathAccessors[index])) return true;
              return accessor === prevPathAccessors[index];
            });
          });
        }
      }
    }
    return false;
  }, [location]);

  return useCallback(() => {
    if (canNavigateBack) {
      navigate(-1);
    } else if (flowResourceType === FlowResourceType.Entity) {
      navigate(routeUrls.thingsGroups.url({ environment }, null));
    } else {
      navigate(routeUrls.workflows.url({ environment }, {}));
    }
  }, [canNavigateBack, flowResourceType, navigate, environment]);
};
